export default __webpack_public_path__ + "static/media/usdc.c8b29eae.svg";